import { render, staticRenderFns } from "./DashboardDocs.vue?vue&type=template&id=4aa3b6fd&scoped=true&"
import script from "./DashboardDocs.vue?vue&type=script&lang=js&"
export * from "./DashboardDocs.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDocs.vue?vue&type=style&index=0&id=4aa3b6fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3b6fd",
  null
  
)

export default component.exports